export const QA_NAME_ENTITY_TAB_BUILDING_GROUPS_ADD_NEW =
  'entityTabBuildingGroupsAddNew'

export const QA_NAME_ENTITY_TAB_BUILDING_GROUPS_EDIT =
  'entityTabBuildingGroupsEdit'
